/* Cosmic Spill theme JS — drawers, AJAX cart, product form, scrollers */
(function () {
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const overlay = $("[data-overlay]");

  /* ---------- drawers ---------- */
  function openPanel(panel) {
    panel.classList.add("is-open");
    overlay.hidden = false;
    document.body.style.overflow = "hidden";
  }
  function closePanels() {
    $$(".drawer.is-open, .cart-drawer.is-open").forEach((p) => p.classList.remove("is-open"));
    overlay.hidden = true;
    document.body.style.overflow = "";
  }
  document.addEventListener("click", (e) => {
    const t = e.target.closest("[data-open-menu],[data-open-cart],[data-close-panel]");
    if (e.target === overlay) return closePanels();
    if (!t) return;
    if (t.hasAttribute("data-close-panel")) return closePanels();
    e.preventDefault();
    closePanels();
    if (t.hasAttribute("data-open-menu")) openPanel($("[data-menu-drawer]"));
    if (t.hasAttribute("data-open-cart")) openPanel($("[data-cart-drawer]"));
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closePanels(); });

  /* ---------- cart ---------- */
  async function refreshCartDrawer(open) {
    const res = await fetch("/?sections=cart-drawer");
    const html = (await res.json())["cart-drawer"];
    const fresh = new DOMParser().parseFromString(html, "text/html").querySelector("[data-cart-drawer]");
    const cur = $("[data-cart-drawer]");
    if (fresh && cur) {
      const wasOpen = cur.classList.contains("is-open");
      cur.replaceWith(fresh);
      if (wasOpen || open) openPanel($("[data-cart-drawer]"));
    }
    const c = await (await fetch("/cart.js")).json();
    $$("[data-cart-count]").forEach((el) => {
      el.textContent = c.item_count;
      c.item_count ? el.removeAttribute("data-zero") : el.setAttribute("data-zero", "");
    });
  }

  document.addEventListener("submit", async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[name="add"]');
    const label = btn ? btn.textContent : "";
    if (btn) { btn.disabled = true; btn.textContent = "ADDING…"; }
    try {
      const res = await fetch("/cart/add.js", { method: "POST", body: new FormData(form) });
      if (!res.ok) throw await res.json();
      await refreshCartDrawer(true);
      if (btn) btn.textContent = "ADDED ✓";
    } catch (err) {
      if (btn) btn.textContent = (err && err.description) ? "SOLD OUT" : "ERROR — TRY AGAIN";
    } finally {
      setTimeout(() => { if (btn) { btn.disabled = false; btn.textContent = label; } }, 1600);
    }
  });

  document.addEventListener("click", async (e) => {
    const chg = e.target.closest("[data-line-change]");
    const rem = e.target.closest("[data-line-remove]");
    if (!chg && !rem) return;
    e.preventDefault();
    const el = chg || rem;
    const line = Number(el.dataset.line);
    const qty = rem ? 0 : Number(el.dataset.qty);
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line, quantity: qty }),
    });
    if ($(".cart-page")) location.reload();
    else refreshCartDrawer(true);
  });

  /* ---------- qty steppers ---------- */
  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-qty-btn]");
    if (!b) return;
    const input = b.parentElement.querySelector("input");
    const v = Math.max(1, Number(input.value || 1) + Number(b.dataset.qtyBtn));
    input.value = v;
  });

  /* ---------- product: variant picker ---------- */
  const pform = $("[data-product-form]");
  if (pform) {
    const data = JSON.parse($("[data-product-json]").textContent);
    const money = (cents) => "$" + (cents / 100).toFixed(2).replace(/\.00$/, "");
    function currentVariant() {
      const sel = $$("fieldset", pform).map((f) => f.querySelector("input:checked")?.value);
      return data.variants.find((v) => sel.every((s, i) => v.options[i] === s));
    }
    function galleryValues() {
      // every option value this product uses, longest first (so "turquoise/red" wins over "red")
      return [...new Set(data.variants.flatMap((v) => v.options))]
        .map((x) => String(x).toLowerCase().trim())
        .sort((a, b) => b.length - a.length);
    }
    function filterGallery(v) {
      const thumbs = $$("[data-thumb]");
      if (thumbs.length < 2 || !v) return;
      const allVals = galleryValues();
      const mine = v.options.map((o) => String(o).toLowerCase().trim());
      let firstVisible = null, firstMatch = null;
      thumbs.forEach((t) => {
        const alt = t.dataset.ialt || "";
        const linked = (t.dataset.ivar || "").split(",").filter(Boolean).map(Number);
        const tagged = allVals.find((val) => alt.includes(val));
        let state; // match | other | neutral
        if (linked.includes(v.id)) state = "match";
        else if (tagged && mine.includes(tagged)) state = "match";
        else if (linked.length || tagged) state = "other";
        else state = "neutral";
        t.style.display = state === "other" ? "none" : "";
        if (state !== "other" && !firstVisible) firstVisible = t;
        if (state === "match" && !firstMatch) firstMatch = t;
      });
      const lead = firstMatch || firstVisible;
      if (lead) {
        const main = $("[data-gallery-main] img");
        if (!v.featured_image) {
          if (lead.dataset.gindex != null && $$(".gmedia").length) {
            $$(".gmedia").forEach((im) => im.classList.toggle("on", im.dataset.gmedia === lead.dataset.gindex));
          } else if (main) { main.removeAttribute("sizes"); main.srcset = lead.dataset.thumb; main.src = lead.dataset.thumb; }
        }
        thumbs.forEach((x) => x.removeAttribute("aria-current"));
        lead.setAttribute("aria-current", "true");
      }
    }
    function update() {
      const v = currentVariant();
      const btn = $('[name="add"]', pform);
      const price = $("[data-price]");
      if (!v) { btn.disabled = true; btn.textContent = "UNAVAILABLE"; return; }
      $('[name="id"]', pform).value = v.id;
      price.innerHTML = money(v.price) +
        (v.compare_at_price > v.price ? " <s>" + money(v.compare_at_price) + "</s>" : "");
      btn.disabled = !v.available;
      btn.textContent = v.available ? "ADD TO CART" : "SOLD OUT";
      const sp = $("[data-sticky-price]"); if (sp) sp.textContent = money(v.price);
      const sb = $("[data-sticky-add]"); if (sb) sb.disabled = !v.available;
      if (v.featured_image) {
        const main = $("[data-gallery-main] img");
        {
          const base = (v.featured_image.src || "").split("?")[0];
          const tb = $$("[data-thumb]").find((x) => (x.dataset.thumb || "").split("?")[0] === base);
          if (tb && tb.dataset.gindex != null && $$(".gmedia").length) {
            $$(".gmedia").forEach((im) => im.classList.toggle("on", im.dataset.gmedia === tb.dataset.gindex));
          } else if (main) { main.removeAttribute("sizes"); main.srcset = v.featured_image.src; main.src = v.featured_image.src; }
        }
      }
      if (window.galleryHideVideos) window.galleryHideVideos();
      filterGallery(v);
      if (window.galleryUpdateCount) window.galleryUpdateCount();
      history.replaceState(null, "", "?variant=" + v.id);
    }
    pform.addEventListener("change", (e) => { if (e.target.matches("input[type=radio]")) update(); });
    filterGallery(currentVariant());
  }

  /* ---------- gallery thumbs ---------- */
  function galleryHideVideos() {
    $$(".gvideo").forEach((v) => {
      if (v.hidden) return; // leave untouched players alone (no reload churn)
      const vid = v.querySelector("video");
      if (vid) vid.pause();
      const fr = v.querySelector("iframe");
      if (fr && fr.src) fr.src = fr.src; // stop external player
      v.hidden = true;
    });
  }
  window.galleryHideVideos = galleryHideVideos;
  function galleryThumbs() {
    return $$("[data-thumb]").filter((t) => t.style.display !== "none");
  }
  function galleryUpdateCount() {
    const el = $("[data-gcount]");
    if (!el) return;
    const list = galleryThumbs();
    if (list.length < 2) { el.textContent = ""; return; }
    const cur = list.findIndex((t) => t.hasAttribute("aria-current"));
    el.textContent = (cur < 0 ? 1 : cur + 1) + " / " + list.length;
  }
  window.galleryUpdateCount = galleryUpdateCount;
  document.addEventListener("click", (e) => {
    const t = e.target.closest("[data-thumb]");
    if (!t) return;
    const main = $("[data-gallery-main] img");
    galleryHideVideos();
    if (t.dataset.video) {
      const v = $('[data-gvideo="' + t.dataset.video + '"]');
      if (v) {
        v.hidden = false;
        const vid = v.querySelector("video");
        if (vid) vid.play().catch(() => {});
      }
    } else if (t.dataset.gindex != null && $$(".gmedia").length) {
      $$(".gmedia").forEach((im) => im.classList.toggle("on", im.dataset.gmedia === t.dataset.gindex));
    } else if (main) {
      main.removeAttribute("sizes");
      main.srcset = t.dataset.thumb;
      main.src = t.dataset.thumb;
    }
    $$("[data-thumb]").forEach((x) => x.removeAttribute("aria-current"));
    t.setAttribute("aria-current", "true");
    galleryUpdateCount();
  });

  /* swipe between product media on touch */
  (function () {
    const wrap = $("[data-gallery-main]");
    if (!wrap) return;
    let sx = 0, sy = 0, live = false, horiz = false;
    wrap.addEventListener("touchstart", (e) => {
      if (e.touches.length !== 1) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; live = true; horiz = false;
    }, { passive: true });
    wrap.addEventListener("touchmove", (e) => {
      if (!live) return;
      const dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
      if (!horiz && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) horiz = true;
      if (horiz) e.preventDefault();
    }, { passive: false });
    wrap.addEventListener("touchend", (e) => {
      if (!live) return;
      live = false;
      const dx = e.changedTouches[0].clientX - sx;
      const dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) < 40 || (!horiz && Math.abs(dx) < Math.abs(dy) * 1.5)) return;
      const list = galleryThumbs();
      if (list.length < 2) return;
      let cur = list.findIndex((t) => t.hasAttribute("aria-current"));
      if (cur < 0) cur = 0;
      const next = dx < 0 ? Math.min(cur + 1, list.length - 1) : Math.max(cur - 1, 0);
      if (next !== cur) list[next].click();
    }, { passive: true });
    galleryUpdateCount();
  })();

  /* ---------- horizontal scrollers ---------- */
  $$("[data-scroller]").forEach((sc) => {
    const track = $(".scroller__track", sc);
    $(".scroller__btn--prev", sc)?.addEventListener("click", () =>
      track.scrollBy({ left: -track.clientWidth * 0.8, behavior: "smooth" }));
    $(".scroller__btn--next", sc)?.addEventListener("click", () =>
      track.scrollBy({ left: track.clientWidth * 0.8, behavior: "smooth" }));
  });

  /* ---------- collection sort ---------- */
  const sort = $("[data-sort]");
  if (sort) sort.addEventListener("change", () => {
    const u = new URL(location.href);
    u.searchParams.set("sort_by", sort.value);
    u.searchParams.delete("page");
    location.href = u;
  });

  /* close desktop nav dropdowns on outside click */
  document.addEventListener("click", (e) => {
    $$(".hdr__nav details[open]").forEach((d) => { if (!d.contains(e.target)) d.removeAttribute("open"); });
  });
})();

/* ===== UX pass additions ===== */
(function () {
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* quick add (single-variant products) */
  document.addEventListener("click", async (e) => {
    const qa = e.target.closest("[data-quick-add]");
    if (!qa) return;
    e.preventDefault(); e.stopPropagation();
    qa.textContent = "…";
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: Number(qa.dataset.quickAdd), quantity: 1 }),
      });
      if (!res.ok) throw 0;
      qa.textContent = "✓"; qa.classList.add("added");
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch { qa.textContent = "✕"; }
    setTimeout(() => { qa.textContent = "＋"; qa.classList.remove("added"); }, 1500);
  });
  document.addEventListener("cart:refresh", async () => {
    const res = await fetch("/?sections=cart-drawer");
    const html = (await res.json())["cart-drawer"];
    const fresh = new DOMParser().parseFromString(html, "text/html").querySelector("[data-cart-drawer]");
    const cur = $("[data-cart-drawer]");
    if (fresh && cur) { cur.replaceWith(fresh); $("[data-cart-drawer]").classList.add("is-open");
      const ov = $("[data-overlay]"); if (ov) ov.hidden = false; }
    const c = await (await fetch("/cart.js")).json();
    $$("[data-cart-count]").forEach((el) => {
      el.textContent = c.item_count;
      c.item_count ? el.removeAttribute("data-zero") : el.setAttribute("data-zero", "");
    });
  });

  /* sticky mobile add-to-cart */
  const buy = $(".buy"), sticky = $("[data-sticky-atc]");
  if (buy && sticky && "IntersectionObserver" in window) {
    new IntersectionObserver(([en]) => sticky.classList.toggle("show", !en.isIntersecting && en.boundingClientRect.top < 0),
      { threshold: 0 }).observe(buy);
    $("[data-sticky-add]")?.addEventListener("click", () => {
      const f = $("[data-product-form]");
      if (f) (f.requestSubmit ? f.requestSubmit() : f.submit());
    });
  }

  /* scroll reveal */
  if ("IntersectionObserver" in window && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
    const io = new IntersectionObserver((ents) => ents.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
    }), { rootMargin: "0px 0px -8% 0px" });
    $$(".card, .tile, .prop, .polaroid").forEach((el, i) => {
      el.classList.add("rv");
      el.style.setProperty("--rvd", (i % 4) * 0.06 + "s");
      io.observe(el);
    });
  }

  /* v2: rotating collection cutouts */
  (function () {
    const groups = $$("[data-rotate]");
    if (!groups.length) return;
    const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
    groups.forEach((g, gi) => {
      const imgs = [...g.querySelectorAll("img")];
      if (!imgs.length) return;
      let i = 0;
      imgs[0].classList.add("on");
      if (imgs.length < 2 || reduce) return;
      let timer = null;
      const tick = () => {
        imgs[i].classList.remove("on");
        i = (i + 1) % imgs.length;
        imgs[i].classList.add("on");
      };
      const start = () => { if (!timer) timer = setInterval(tick, 3800 + gi * 350); };
      const stop = () => { clearInterval(timer); timer = null; };
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(([en]) => (en.isIntersecting ? start() : stop()), { threshold: 0.2 }).observe(g);
      } else start();
    });
  })();

  /* v2: podium showcase */
  (function () {
    const root = $("[data-podium]");
    if (!root) return;
    const items = $$("[data-podium-item]", root);
    if (items.length < 2) { if (items[0]) items[0].classList.add("pos-center"); return; }
    const label = $("[data-podium-label]", root);
    const colEl = $("[data-podium-col]", root);
    const colLink = $("[data-podium-collink]", root);
    const btn = $("[data-podium-btn]", root);
    const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
    const speed = (Number(root.dataset.speed) || 5) * 1000;
    let idx = 0, timer = null, visible = false;

    function paint(withFade) {
      const n = items.length;
      items.forEach((it, i) => {
        const rel = (i - idx + n) % n;
        it.classList.remove("pos-left", "pos-right", "pos-hidden");
        if (rel === 0) return;
        if (rel === 1) it.classList.add("pos-right");
        else if (rel === n - 1) it.classList.add("pos-left");
        else it.classList.add("pos-hidden");
      });
      const cur = items[idx];
      const apply = () => {
        colEl.textContent = "";
        {
          const words = (cur.dataset.col || "").split(" ");
          if (words.length > 1) {
            const top = document.createElement("span"); top.className = "t-top";
            top.textContent = words.slice(0, -1).join(" ") + " ";
            const last = document.createElement("span"); last.className = "t-last";
            last.textContent = words[words.length - 1];
            colEl.append(top, last);
          } else colEl.textContent = cur.dataset.col;
        }
        colLink.href = cur.dataset.link || "#";
        colLink.className = "podium__col cf-" + (cur.dataset.namestyle || "playfair");
        btn.href = cur.dataset.link || "#";
      };
      if (withFade && label) {
        label.classList.add("fade");
        setTimeout(() => { apply(); label.classList.remove("fade"); }, 280);
      } else apply();
    }
    function go(d) { idx = (idx + d + items.length) % items.length; paint(true); }
    function start() { if (!timer && !reduce && visible) timer = setInterval(() => go(1), speed); }
    function stop() { clearInterval(timer); timer = null; }

    items.forEach((it, i) => it.addEventListener("click", () => {
      const rel = (i - idx + items.length) % items.length;
      if (rel === 0) { if (it.dataset.link) window.location.href = it.dataset.link; return; }
      stop(); idx = i; paint(true); start();
    }));
    $("[data-podium-prev]", root)?.addEventListener("click", () => { stop(); go(-1); start(); });
    $("[data-podium-next]", root)?.addEventListener("click", () => { stop(); go(1); start(); });
    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(([en]) => { visible = en.isIntersecting; visible ? start() : stop(); }, { threshold: 0.25 }).observe(root);
    } else { visible = true; start(); }
    paint(false);
  })();

  /* v2: twinkling star fields across decorative sections */
  (function () {
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const spots = [
      [".heroV2", 6], [".arches", 6], [".band", 4],
      [".podium", 6], [".newsletter", 3], [".footer", 4],
    ];
    spots.forEach(([sel, count]) => {
      const host = $(sel);
      if (!host || host.querySelector(".v2-stars")) return;
      const field = document.createElement("div");
      field.className = "v2-stars";
      field.setAttribute("aria-hidden", "true");
      for (let i = 0; i < count; i++) {
        const st = document.createElement("span");
        st.textContent = i % 3 === 2 ? "✧" : "✦";
        st.style.left = (4 + Math.random() * 92) + "%";
        st.style.top = (5 + Math.random() * 86) + "%";
        st.style.setProperty("--fs", (8 + Math.random() * 12).toFixed(0) + "px");
        st.style.setProperty("--d", (3.2 + Math.random() * 3.6).toFixed(2) + "s");
        st.style.setProperty("--dl", (Math.random() * 4).toFixed(2) + "s");
        field.appendChild(st);
      }
      let bg = host.querySelector('[class$="__bg"]');
      if (bg && bg.parentElement !== host) bg = null;
      host.insertBefore(field, bg ? bg.nextSibling : host.firstChild);
    });
  })();

  /* v2: hero scene alternation */
  (function () {
    const hero = $("[data-hero-alt]");
    if (!hero || !hero.querySelector(".heroV2__set-b")) return;
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const ms = (Number(hero.dataset.heroAlt) || 7) * 1000;
    let timer = null;
    const start = () => { if (!timer) timer = setInterval(() => hero.classList.toggle("alt"), ms); };
    const stop = () => { clearInterval(timer); timer = null; };
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(([en]) => (en.isIntersecting ? start() : stop()), { threshold: 0.2 }).observe(hero);
    } else start();
  })();

  /* v2: fullscreen image lightbox on product gallery */
  (function () {
    const mainWrap = $("[data-gallery-main]");
    if (!mainWrap) return;
    const mainImg = mainWrap.querySelector("img");
    if (!mainImg) return;
    const urls = () => {
      const t = $$("[data-thumb]").map((b) => b.dataset.thumb);
      return t.length ? t : [mainImg.src];
    };
    const lb = document.createElement("div");
    lb.className = "lightbox";
    lb.innerHTML = '<button class="lightbox__close" aria-label="Close">✕</button>' +
      '<button class="lightbox__prev" aria-label="Previous">←</button>' +
      '<img alt="">' +
      '<button class="lightbox__next" aria-label="Next">→</button>' +
      '<span class="lightbox__count"></span>';
    document.body.appendChild(lb);
    const img = lb.querySelector("img"), count = lb.querySelector(".lightbox__count");
    let list = [], i = 0;
    const show = () => {
      img.src = list[i];
      count.textContent = (i + 1) + " / " + list.length;
      lb.querySelector(".lightbox__prev").style.display = list.length > 1 ? "" : "none";
      lb.querySelector(".lightbox__next").style.display = list.length > 1 ? "" : "none";
    };
    const open = () => {
      list = urls();
      i = Math.max(0, list.indexOf(mainImg.src));
      if (i === -1) i = 0;
      show();
      lb.classList.add("open");
      document.body.style.overflow = "hidden";
    };
    const close = () => { lb.classList.remove("open"); document.body.style.overflow = ""; };
    mainWrap.addEventListener("click", (e) => {
      if (e.target.closest(".gvideo")) return;
      if (mainWrap.querySelector(".gvideo:not([hidden])")) return;
      open();
    });
    lb.addEventListener("click", (e) => { if (e.target === lb || e.target.closest(".lightbox__close")) close(); });
    lb.querySelector(".lightbox__prev").addEventListener("click", () => { i = (i - 1 + list.length) % list.length; show(); });
    lb.querySelector(".lightbox__next").addEventListener("click", () => { i = (i + 1) % list.length; show(); });
    document.addEventListener("keydown", (e) => {
      if (!lb.classList.contains("open")) return;
      if (e.key === "Escape") close();
      if (e.key === "ArrowLeft") { i = (i - 1 + list.length) % list.length; show(); }
      if (e.key === "ArrowRight") { i = (i + 1) % list.length; show(); }
    });
  })();

  /* v2: shop-by group toggle on collection tabs */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-shopby-btn]");
    if (!btn) return;
    const n = btn.dataset.shopbyBtn;
    $$("[data-shopby-btn]").forEach((b) => b.classList.toggle("is-on", b === btn));
    $$("[data-shopby-panel]").forEach((p) => p.classList.toggle("is-hidden", p.dataset.shopbyPanel !== n));
  });

  /* v2: shop-in collection dropdown */
  document.addEventListener("change", (e) => {
    const sel = e.target.closest("[data-shopin]");
    if (sel && sel.value) window.location.href = sel.value;
  });

  /* v2: editorial banner carousel */
  (function () {
    const band = $("[data-band]");
    if (!band) return;
    const slides = $$(".band__slide", band);
    if (slides.length < 2) return;
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const ms = (Number(band.dataset.band) || 4) * 1000;
    const dots = $$(".band__dots button", band);
    let i = 0, timer = null, hovered = false;
    const show = (n) => {
      slides[i].classList.remove("on"); if (dots[i]) dots[i].classList.remove("on");
      i = n;
      slides[i].classList.add("on"); if (dots[i]) dots[i].classList.add("on");
    };
    const tick = () => show((i + 1) % slides.length);
    const start = () => { if (!timer) timer = setInterval(tick, ms); };
    const stop = () => { clearInterval(timer); timer = null; };
    dots.forEach((d, n) => d.addEventListener("click", (e) => {
      e.preventDefault(); e.stopPropagation();
      show(n); stop(); if (!hovered) start();
    }));
    band.addEventListener("mouseenter", () => { hovered = true; stop(); });
    band.addEventListener("mouseleave", () => { hovered = false; start(); });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(([en]) => (en.isIntersecting ? start() : stop()), { threshold: 0.25 }).observe(band);
    } else start();
  })();

  /* v2: preload gallery images so swipes are instant (HEIC transcodes are slow cold) */
  (function () {
    const thumbs = $$("[data-thumb]");
    if (!thumbs.length) return;
    const warm = () => thumbs.forEach((t) => {
      if (t.dataset.video) return;
      const im = new Image();
      im.src = t.dataset.thumb;
    });
    if ("requestIdleCallback" in window) requestIdleCallback(warm, { timeout: 3000 });
    else setTimeout(warm, 1200);
  })();

  /* v2: cap + shuffle sold-out items in grids (in-stock first, max 4 random sold-out shown) */
  (function () {
    var SOLDOUT_SHOWN = 4;
    $$(".grid").forEach(function (grid) {
      var sold = $$(".card", grid).filter(function (c) { return c.querySelector(".quick-add--sold"); });
      if (sold.length <= SOLDOUT_SHOWN) return;
      for (var i = sold.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = sold[i]; sold[i] = sold[j]; sold[j] = t;
      }
      sold.forEach(function (c, i) {
        grid.appendChild(c);
        if (i >= SOLDOUT_SHOWN) c.style.display = "none";
      });
      var soon = grid.querySelector(".card--soon");
      if (soon) grid.appendChild(soon);
    });
  })();

  /* v2: restock bell — sold-out items, first tap explains, then rings */
  (function () {
    var SEEN = "cs_bell_seen";
    var EMAIL = "cs_bell_email";
    var busy = false;
    function savedEmail() {
      try { return localStorage.getItem(EMAIL) || ""; } catch (err) { return ""; }
    }
    function ting() {
      try {
        var Ctx = window.AudioContext || window.webkitAudioContext;
        var ctx = new Ctx();
        function note(t, f) {
          var o = ctx.createOscillator(), g = ctx.createGain();
          o.type = "sine"; o.frequency.value = f;
          g.gain.setValueAtTime(0.0001, t);
          g.gain.exponentialRampToValueAtTime(0.35, t + 0.012);
          g.gain.exponentialRampToValueAtTime(0.0001, t + 0.7);
          o.connect(g); g.connect(ctx.destination);
          o.start(t); o.stop(t + 0.75);
        }
        note(ctx.currentTime, 1567.98);
        note(ctx.currentTime + 0.18, 2093);
      } catch (e) {}
    }
    function toast(msg) {
      var t = document.querySelector(".cs-toast");
      if (!t) { t = document.createElement("div"); t.className = "cs-toast"; document.body.appendChild(t); }
      t.textContent = msg;
      t.classList.add("on");
      clearTimeout(t._tm);
      t._tm = setTimeout(function () { t.classList.remove("on"); }, 2600);
    }
    function send(btn, email) {
      var note = email
        ? "Notify when back: " + email
        : "Anonymous ring (no email left)";
      var body = new URLSearchParams({
        shop_domain: "2326ce-6d.myshopify.com",
        platform: "shopify",
        name: "Restock Bell",
        email: email || "restock-bell@cosmicspill.shop",
        question_content: "🔔 Restock bell rang — a customer wants " + (btn.dataset.bellTitle || "this piece") + " back in stock. " + note + ". " + location.origin + (btn.dataset.bellUrl || location.pathname),
        id: btn.dataset.bellId || ""
      });
      fetch("https://api.judge.me/api/questions", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString()
      }).catch(function () {});
    }
    function ring(btn, email) {
      if (busy) return;
      busy = true;
      send(btn, email);
      ting();
      toast("🔔 Restock bell rang" + (email ? " — we'll email you" : ""));
      btn.classList.add("rung");
      setTimeout(function () { busy = false; btn.classList.remove("rung"); }, 2600);
    }
    function pop(btn) {
      var ov = document.createElement("div");
      ov.className = "bell-pop";
      ov.innerHTML =
        '<div class="bell-pop__card" role="dialog" aria-label="Restock bell">' +
        '<button class="bell-pop__x" type="button" aria-label="Close">×</button>' +
        '<p class="bell-pop__bell">🔔</p>' +
        '<h3>RING THE RESTOCK BELL</h3>' +
        '<p>This piece is sold out. Ring the bell so we know you want it back — the more rings, the faster we restock it.</p>' +
        '<input class="bell-pop__email" type="email" inputmode="email" autocomplete="email" ' +
          'placeholder="your@email.com" aria-label="Email for restock alert (optional)">' +
        '<p class="bell-pop__email-hint">Optional — leave your email and we’ll ping you when it’s back.</p>' +
        '<p class="bell-pop__err" hidden>That email doesn’t look right — fix it or clear it.</p>' +
        '<button class="btn bell-pop__cta" type="button">RING BELL</button></div>';
      document.body.appendChild(ov);
      var input = ov.querySelector(".bell-pop__email");
      var errEl = ov.querySelector(".bell-pop__err");
      ov.addEventListener("click", function (e) {
        if (e.target === ov || e.target.closest(".bell-pop__x")) ov.remove();
        if (e.target.closest(".bell-pop__cta")) {
          var email = input.value.trim();
          if (email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
            errEl.hidden = false;
            input.focus();
            return;
          }
          errEl.hidden = true;
          try {
            localStorage.setItem(SEEN, "1");
            if (email) localStorage.setItem(EMAIL, email);
          } catch (err) {}
          ov.remove();
          ring(btn, email);
        }
      });
      input.addEventListener("keydown", function (e) {
        if (e.key === "Enter") { e.preventDefault(); ov.querySelector(".bell-pop__cta").click(); }
      });
    }
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-bell]");
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var email = savedEmail();
      /* once they've left an email, rings are instant one-tap; until then the
         popup asks each time (email stays optional — RING BELL works blank) */
      if (email) ring(btn, email); else pop(btn);
    }, true);
  })();
})();
